module.exports = "<ul class=\"list1\" id=\"menu\">\n  <li class=\"list-inline-item\" *ngFor=\"let p of pageList\">\n    <a class=\"nav-link\" href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\">\n      <span>{{p.KHB_Page}}</span>\n    </a>\n  </li>\n</ul>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-reports/sainik-reports.component.html
// module id = ./src/app/sainik-reports/sainik-reports.component.html
// module chunks = main